/* eslint-disable  @typescript-eslint/ban-ts-comment */
// @ts-nocheck
// @mui material components
import { createTheme } from '@mui/material/styles';
// import Fade from "@mui/material/Fade";

import colors from 'src/theme/base/colors';
import breakpoints from 'src/theme/base/breakpoints';
import typography from 'src/theme/base/typography';
import boxShadows from 'src/theme/base/boxShadows';
import borders from 'src/theme/base/borders';
import globals from 'src/theme/base/globals';

import boxShadow from 'src/theme/functions/boxShadow';
import hexToRgb from 'src/theme/functions/hexToRgb';
import linearGradient from 'src/theme/functions/linearGradient';
import pxToRem from 'src/theme/functions/pxToRem';
import rgba from 'src/theme/functions/rgba';

import sidenav from 'src/theme/components/sidenav';
import list from 'src/theme/components/list';
import listItem from 'src/theme/components/list/listItem';
import listItemText from 'src/theme/components/list/listItemText';
import card from 'src/theme/components/card';
import cardMedia from 'src/theme/components/card/cardMedia';
import cardContent from 'src/theme/components/card/cardContent';
import button from 'src/theme/components/button';
import iconButton from 'src/theme/components/iconButton';
import inputBase from 'src/theme/components/form/inputBase';
import menu from 'src/theme/components/menu';
import menuItem from 'src/theme/components/menu/menuItem';
import switchButton from 'src/theme/components/form/switchButton';
import divider from 'src/theme/components/divider';
import tableContainer from 'src/theme/components/table/tableContainer';
import tableHead from 'src/theme/components/table/tableHead';
import tableCell from 'src/theme/components/table/tableCell';
import linearProgress from 'src/theme/components/linearProgress';
import breadcrumbs from 'src/theme/components/breadcrumbs';
import slider from 'src/theme/components/slider';
import avatar from 'src/theme/components/avatar';
import tooltip from 'src/theme/components/tooltip';
import appBar from 'src/theme/components/appBar';
import tabs from 'src/theme/components/tabs';
import tab from 'src/theme/components/tabs/tab';
import stepper from 'src/theme/components/stepper';
import step from 'src/theme/components/stepper/step';
import stepConnector from 'src/theme/components/stepper/stepConnector';
import stepLabel from 'src/theme/components/stepper/stepLabel';
import stepIcon from 'src/theme/components/stepper/stepIcon';
import select from 'src/theme/components/form/select';
import formControlLabel from 'src/theme/components/form/formControlLabel';
import formLabel from 'src/theme/components/form/formLabel';
import checkbox from 'src/theme/components/form/checkbox';
import radio from 'src/theme/components/form/radio';
import autocomplete from 'src/theme/components/form/autocomplete';
import input from 'src/theme/components/form/input';
import flatpickr from 'src/theme/components/flatpickr';
import swal from 'src/theme/components/swal';
import container from 'src/theme/components/container';
import popover from 'src/theme/components/popover';
import buttonBase from 'src/theme/components/buttonBase';
import icon from 'src/theme/components/icon';
import svgIcon from 'src/theme/components/svgIcon';
import link from 'src/theme/components/link';
import dialog from 'src/theme/components/dialog';
import dialogTitle from 'src/theme/components/dialog/dialogTitle';
import dialogContent from 'src/theme/components/dialog/dialogContent';
import dialogContentText from 'src/theme/components/dialog/dialogContentText';
import dialogActions from 'src/theme/components/dialog/dialogActions';

export default createTheme({
  breakpoints: { ...breakpoints },
  palette: { ...colors },
  typography: { ...typography },
  boxShadows: { ...boxShadows },
  borders: { ...borders },
  functions: {
    boxShadow,
    hexToRgb,
    linearGradient,
    pxToRem,
    rgba,
  },

  components: {
    MuiCssBaseline: {
      styleOverrides: {
        ...globals,
        ...flatpickr,
        ...swal,
        ...container,
      },
    },
    MuiDrawer: { ...sidenav },
    MuiList: { ...list },
    MuiListItem: { ...listItem },
    MuiListItemText: { ...listItemText },
    MuiCard: { ...card },
    MuiCardMedia: { ...cardMedia },
    MuiCardContent: { ...cardContent },
    MuiButton: { ...button },
    MuiIconButton: { ...iconButton },
    MuiInputBase: { ...inputBase },
    MuiMenu: { ...menu },
    MuiMenuItem: { ...menuItem },
    MuiSwitch: { ...switchButton },
    MuiDivider: { ...divider },
    MuiTableContainer: { ...tableContainer },
    MuiTableHead: { ...tableHead },
    MuiTableCell: { ...tableCell },
    MuiLinearProgress: { ...linearProgress },
    MuiBreadcrumbs: { ...breadcrumbs },
    MuiSlider: { ...slider },
    MuiAvatar: { ...avatar },
    MuiTooltip: { ...tooltip },
    MuiAppBar: { ...appBar },
    MuiTabs: { ...tabs },
    MuiTab: { ...tab },
    MuiStepper: { ...stepper },
    MuiStep: { ...step },
    MuiStepConnector: { ...stepConnector },
    MuiStepLabel: { ...stepLabel },
    MuiStepIcon: { ...stepIcon },
    MuiSelect: { ...select },
    MuiFormControlLabel: { ...formControlLabel },
    MuiFormLabel: { ...formLabel },
    MuiCheckbox: { ...checkbox },
    MuiRadio: { ...radio },
    MuiAutocomplete: { ...autocomplete },
    MuiInput: { ...input },
    MuiOutlinedInput: { ...input },
    MuiFilledInput: { ...input },
    MuiPopover: { ...popover },
    MuiButtonBase: { ...buttonBase },
    MuiIcon: { ...icon },
    MuiSvgIcon: { ...svgIcon },
    MuiLink: { ...link },
    MuiDialog: { ...dialog },
    MuiDialogTitle: { ...dialogTitle },
    MuiDialogContent: { ...dialogContent },
    MuiDialogContentText: { ...dialogContentText },
    MuiDialogActions: { ...dialogActions },
  },
});
